const error = {
  userLimitReached: "Users limit reached.",
};

export { error };
